import { DateTimeFormatStyle, useI18nContext } from "@hopper-b2b/i18n";
import { WatchCardComponentProps } from "./WatchCard";
import dayjs from "dayjs";
import { Recommendation } from "@b2bportal/air-shopping-api";
import { useCallback, useMemo } from "react";

const DATE_FORMAT = DateTimeFormatStyle.ShortMonthDayShortWeekday;
const SHORT_TIME_FORMAT = DateTimeFormatStyle.ShortTime;

export const useWatchCard = (props: WatchCardComponentProps) => {
  const { watch, tripContext } = props;
  const { t, formatDateTime } = useI18nContext();
  const { origin, destination, departureDate, returnDate } = watch.key.value;
  const originLabel =
    tripContext.airports[origin.code]?.servedCityName ??
    tripContext.cities[origin.code]?.name ??
    origin.code;
  const destinationLabel =
    tripContext.airports[destination.code]?.servedCityName ??
    tripContext.cities[destination.code]?.name ??
    destination.code;

  const getWatchCardTitle = useCallback(() => {
    return t("originToDestination", {
      origin: `${originLabel} (${origin.code})`,
      destination: `${destinationLabel} (${destination.code})`,
      interpolation: { escapeValue: false },
    });
  }, [destination.code, destinationLabel, origin.code, originLabel, t]);

  return useMemo(() => {
    return {
      text: {
        title: getWatchCardTitle(),
        departureDate: formatDateTime(
          dayjs(departureDate).toDate(),
          DATE_FORMAT
        ),
        returnDate: formatDateTime(dayjs(returnDate).toDate(), DATE_FORMAT),
        departureTime: formatDateTime(
          dayjs(departureDate).toDate(),
          SHORT_TIME_FORMAT
        ),
        returnTime:
          returnDate !== null && returnDate !== undefined
            ? formatDateTime(dayjs(returnDate).toDate(), SHORT_TIME_FORMAT)
            : "",
        tripType:
          returnDate !== null && returnDate !== undefined
            ? t("flightRoundTrip")
            : t("flightOneWay"),
        recommendation:
          watch.recommendation === Recommendation.Buy
            ? t("watch.bookNowTagLabel")
            : t("watch.waitTagLabel"),
      },
    };
  }, [
    departureDate,
    formatDateTime,
    getWatchCardTitle,
    returnDate,
    t,
    watch.recommendation,
  ]);
};
